
import PersonaBadge from "features/journey-map/cards/PersonaBadge";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import EditModeSwitch from "shared/components/edit-mode-switch";
import GenericTypeahead from "shared/dropdowns/GenericTypeahead";
import { SwitchProvider } from "shared/dynamic-imports";

export default function PersonaDropdown({ object, recordType, link, unlink, menuListHeight, isOpen=false, isSwitchDisabled }) {
	const { personaIdStr, cjmIdStr } = useLocation().search.getAllMapsParams();
	const showSampleData = useSelector(({ settings }) => settings.organization?.showSampleData);
	const allPersonas = useSelector((state) => state.personas.all_personas?.getActiveRecords(!showSampleData));
	const linkedPersonas = allPersonas?.filter((p) => object?.linkedPersonas?.includes(p?.personaId)) || [];
	const linkedPersonasOnMap = useSelector((state) => state.maps.current_map.cjmPersonasData) || [];
	const renderReadOnlyItems = () => (
		<>
			{linkedPersonas?.map((p) => (
				<div key={p?.personaId}>
					<PersonaBadge info={cjmIdStr && !linkedPersonasOnMap.find((persona) => persona.personaId === p?.personaId)} object={p} classNames="" />
				</div>
			))}
		</>
	);

	const params = {
		selected: linkedPersonas,
		options: allPersonas,
		idAttribute: "personaId",
		renderSelectedItem: (persona) => <PersonaBadge key={persona?.personaId} info={cjmIdStr && !linkedPersonasOnMap.find((p) => p.personaId === persona?.personaId)} object={persona} isEdit={true} unlink={unlink} classNames="" />,
		renderMenuItem: ({ item }) => <PersonaBadge object={item} classNames="" />,
		linkMenuItem: ({ item }) => link(item.personaId),
		filter: ({ query, option }) => {
			const persona = allPersonas?.find((p) => p.personaId === option?.personaId);
			if (persona && !linkedPersonas.map((lp) => lp?.personaId)?.includes(option?.personaId)) return persona?.name?.toLowerCase().includes(query?.toLowerCase());
        },
        menuListHeight,
		isStrictOpen: isOpen ? isOpen : null,
	};

	const render = () => {

		if (recordType === "cem_customerexperience") {
			const currentPersona = allPersonas?.find((p) => p.personaId === personaIdStr);
			return <PersonaBadge object={currentPersona} classNames="" />;
		}
		return (
            <SwitchProvider initialValue={ isOpen} isDisabled={isSwitchDisabled}>
				<EditModeSwitch addLabel="JS_151" renderReadOnlyItems={renderReadOnlyItems} isEmpty={linkedPersonas?.length === 0} isDisabled={isSwitchDisabled}>
					<GenericTypeahead {...params} />
				</EditModeSwitch>
			</SwitchProvider>
		);

	};

	return render();
}
